import { takeLatest, put, call } from 'redux-saga/effects';

import { listControlePragaDoenca } from '../service';
import {
  NEW_FILTER_CONTROLE_PRAGA_DOENCA,
  NEW_FILTER_CONTROLE_PRAGA_DOENCA_PENDING,
  NEW_FILTER_CONTROLE_PRAGA_DOENCA_SUCCESS,
  NEW_FILTER_CONTROLE_PRAGA_DOENCA_FAILURE,
} from '../actionTypes';
import { CONST_FILTER_CONTROLE_PRAGA_DOENCA, CONST_ROWS_PER_PAGE } from '@commons/consts';
import { formatDateYYYYMMDD } from '@components/common/format';

function* sagaNewFilterControlePragaDoenca(action) {
  yield put({ type: NEW_FILTER_CONTROLE_PRAGA_DOENCA_PENDING });

  try {
    let filterSaved = sessionStorage.getItem(CONST_FILTER_CONTROLE_PRAGA_DOENCA) !== null
      ? JSON.parse(sessionStorage.getItem(CONST_FILTER_CONTROLE_PRAGA_DOENCA))
      : null;

    let dataInicial = '';
    let dataFinal = '';
    var date = new Date();

    let newFilter = {
      dataInicial: null,
      dataFinal: null,
      talhao: null,
      tipo: null,
      pragaDoenca: null,
      funcionario: null,
      rows: filterSaved?.rows || CONST_ROWS_PER_PAGE,
      page: filterSaved?.page || 0,
      where: ''
    };

    if (filterSaved === null || filterSaved === undefined) {
      // Primeira vez - seta data do mês atual
      dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 1));
      dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 0));

      newFilter = {
        ...newFilter,
        dataInicial,
        dataFinal,
        where: ''
      };
    } else {
      // Aplicar novo filtro
      if (action.newFilter) {
        // Quando aplica um novo filtro, volta para a primeira página
        newFilter.page = 0;

        let where = '';

        // Seta filtro de período
        // typePeriodo = 0 -> periodo manual
        // typePeriodo = 1 -> hoje
        // typePeriodo = 2 -> esta semana
        // typePeriodo = 3 -> mes passado
        // typePeriodo = 4 -> este mes
        // typePeriodo = 5 -> proximo mes
        // typePeriodo = 6 -> este ano
        if (action.typePeriodo === undefined || action.typePeriodo === 0) {
          dataInicial = action.args.dataInicial;
          dataFinal = action.args.dataFinal;
        } else if (action.typePeriodo === 1) {
          dataInicial = formatDateYYYYMMDD(new Date(date));
          dataFinal = formatDateYYYYMMDD(new Date(date));
        } else if (action.typePeriodo === 2) {
          const primeiro = date.getDate() - date.getDay();
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), primeiro));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), primeiro + 6));
        } else if (action.typePeriodo === 3) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() - 1, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 0));
        } else if (action.typePeriodo === 4) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 0));
        } else if (action.typePeriodo === 5) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 2, 0));
        } else if (action.typePeriodo === 6) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), 0, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), 12, 0));
        }

        if (dataInicial !== null && dataInicial !== undefined && dataInicial !== '') {
          where = where + '&dataInicial=' + dataInicial;
        }

        if (dataFinal !== null && dataFinal !== undefined && dataFinal !== '') {
          where = where + '&dataFinal=' + dataFinal;
        }

        if (action.args.talhao !== null && action.args.talhao !== undefined) {
          where = where + '&talhao=' + action.args.talhao.id;
        }

        if (action.args.tipo !== null && action.args.tipo !== undefined) {
          where = where + '&tipo=' + action.args.tipo;
        }

        if (action.args.pragaDoenca !== null && action.args.pragaDoenca !== undefined) {
          where = where + '&pragaDoenca=' + action.args.pragaDoenca.id;
        }

        if (action.args.funcionario !== null && action.args.funcionario !== undefined) {
          where = where + '&responsavel=' + action.args.funcionario.id; // Backend espera 'usuario'
        }

        newFilter = {
          ...newFilter,
          ...action.args,
          dataInicial,
          dataFinal,
          where: where
        };
      } else {
        // Buscar filtro salvo
        let where = '';

        if (filterSaved.dataInicial !== null && filterSaved.dataInicial !== undefined) {
          where = where + '&dataInicial=' + filterSaved.dataInicial;
        }

        if (filterSaved.dataFinal !== null && filterSaved.dataFinal !== undefined) {
          where = where + '&dataFinal=' + filterSaved.dataFinal;
        }

        if (filterSaved.talhao !== null && filterSaved.talhao !== undefined) {
          where = where + '&talhao=' + filterSaved.talhao.id;
        }

        if (filterSaved.tipo !== null && filterSaved.tipo !== undefined) {
          where = where + '&tipo=' + filterSaved.tipo;
        }

        if (filterSaved.pragaDoenca !== null && filterSaved.pragaDoenca !== undefined) {
          where = where + '&pragaDoenca=' + filterSaved.pragaDoenca.id;
        }

        if (filterSaved.funcionario !== null && filterSaved.funcionario !== undefined) {
          where = where + '&responsavel=' + filterSaved.funcionario.id;
        }

        newFilter = { 
          ...filterSaved,
          where: where
        };
      }
    }

    // Buscar registros
    const queryString = `?size=${newFilter.rows}&page=${newFilter.page}${newFilter.where}`;
    const list = yield call(listControlePragaDoenca, queryString);

    sessionStorage.setItem(CONST_FILTER_CONTROLE_PRAGA_DOENCA, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_CONTROLE_PRAGA_DOENCA_SUCCESS,
      list: list,
      filter: newFilter
    });
  } catch (error) {
    yield put({ type: NEW_FILTER_CONTROLE_PRAGA_DOENCA_FAILURE });
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchNewFilterControlePragaDoenca() {
  yield takeLatest(NEW_FILTER_CONTROLE_PRAGA_DOENCA, sagaNewFilterControlePragaDoenca);
}
